import { getLowestItemPrice, isDiscountItemPrice, isMemberRewardItemPrice } from './item-price-utils';
export const getPriceRestrictionFromLowestItemPrice = (sellableItem) => {
    const lowestItemPrice = getLowestItemPrice(sellableItem.prices);
    if (!lowestItemPrice)
        return;
    if (isDiscountItemPrice(lowestItemPrice))
        return { discountId: lowestItemPrice.discountId };
    if (isMemberRewardItemPrice(lowestItemPrice))
        return { rewardId: lowestItemPrice.rewardId };
};
